<template>
  <div class="baniere md:flex pt-24 pb-24">
    <div class="bloc1 pt-4">
      <divider
        :height="diviserHeight"
        :color="diviserColor"
        data-aos="fade-right"
        data-aos-duration="1000"
      />
      <div
        class="titre w-full mt-5"
        data-aos="fade-up"
        data-aos-duration="2000"
      >
        Nous accélérons les projets innovants des startups et groupes
      </div>
    </div>

    <div
      class="bloc2 md:pl-20 pl-0 md:mt-0 mt-10"
      data-aos="fade-up"
      data-aos-duration="3000"
    >
      <div class="title1">
        DE L’IDÉE À LA CONCEPTION PRODUIT
      </div>
      <div class="title2 mt-2">
        À l'instar du monde qui nous entoure et des entreprises avec lesquelles nous travaillons, notre pratique de la conception produit est en perpétuelle évolution depuis 2017.
      </div>
      <div class="title3 mt-16">
        41DEVS  accélère les projets innovants des startups et groupes, de la stratégie produit, à la conception, jusqu’à la livraison, pour des utilisateurs satisfaits et des impacts business rapides.
        Nous avons fait de l’innovation et de la l’ops notre spécialité et nous nous efforçons toujours à trouver le meilleur moyen d’aller plus vite pour vous faire gagner en temps et en argent.
      </div>
    </div>
  </div>
</template>

<script>
import divider from '@/components/helper/divider'

export default {
  name: 'Index',
  components: {
    divider
  },
  props: {
  },
  data () {
    return {
      diviserColor: '#9FB4FE',
      diviserHeight: '5px'
    }
  },
  created () {
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
  @import "../../../assets/style/sass/variables";
 .baniere{
   height: auto ;
   background-color: $white;
   position: relative;
   padding-left: $padding-l;
   padding-right: $padding-r;
 }
  .bloc1{
    width: 30%;
  }
  .bloc2{
    width: 70%;
    font-weight: bold;
    font-size: 24px;
    line-height: 160%;
  }

  .titre{
    font-weight: 800;
    font-size: 40px;
    line-height: 150%;
    letter-spacing: 0.01em;
    color: $black
  }
  .title1{
    text-transform: uppercase;
    color: #9395A2;
  }
  .title2{
    font-size: 32px;
    color: $black;
    line-height: 51.2px;
  }
  .title3{
    font-weight: 400;
    color: $black;
  }
  @media screen and (max-width: 600px){
    .baniere{
      padding-left: 20px;
      padding-right: 20px;
    }
    .title{
      font-size: 32px;
      line-height: 170%;
    }
    .bloc1{
      width: 100%;
    }
    .bloc2{
      width: 100%;
      font-size: 18px;
    }
    .titre{
      font-size: 28px;
    }
    .title1{
      font-size: 18px;
    }
    .title2{
      font-size: 25px;
      line-height: 160%;
    }
  }
  @media screen and (min-width: 701px) and (max-width: 1024px){
    .baniere{
      padding-left: $padding-l-1024;
      padding-right: $padding-r-1024;
    }
    .titre{
      font-size: 35px;
    }
    .title2{
      font-size: 28px;
    }
    .title1{
      font-size: 20px;
    }
    .title3{
      font-size: 20px;
    }
  }
</style>
